import React, { useEffect, useState } from "react";
import {
  Button,
  ButtonWithIcon,
  Checkbox,
  Modal,
  ModalBody,
  ModalHeader,
  Textbox,
  TextButton,
} from "../../ui";
import { B1, L, SLableIcon } from "../../ui/Typography";
import {
  CalenderIcon,
  Call,
  FacebookIcon,
  GoogleIcon,
  LoadingIcon,
  LoadingSuccess,
  TwitterIcon,
} from "../../ui/icons";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  registerUser,
  clearAuthError,
  clearResponseMsg,
} from "../../redux/reducers/AuthReducer";
import Loading from "../../components/Loading";

function TempSignUp({ isOpen, onClose, onSwitchToLogin }) {
  const dispatch = useDispatch();

  /* === useState === */
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [showLoading, setShowLoading] = useState(false);
  const [loadingTitle, setLoadingTitle] = useState("");
  const [loadingIcon, setLoadingIcon] = useState(() => LoadingIcon);

  /* === Redux State === */
  const { loading, error, responseMsg } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isOpen) {
      setEmail("");
      setPhone("");
      setPassword("");
      setConfirmPassword("");
      setEmailError("");
      setPhoneError("");
      setPasswordError("");
      dispatch(clearAuthError());
      dispatch(clearResponseMsg());
    }
  }, [isOpen]);

  useEffect(() => {
    if (responseMsg) {
      setLoadingTitle(responseMsg);
      setLoadingIcon(() => LoadingSuccess);

      setTimeout(() => {
        setShowLoading(false);
        onClose();
      }, 2000);
    }
  }, [responseMsg]);

  useEffect(() => {
    if (error && showLoading) {
      setShowLoading(false);
    }
  }, [error]);

  const handleRegister = () => {
    let valid = true;
    setEmailError("");
    setPasswordError("");
    setPhoneError("");

    if (!email) {
      setEmailError("Email is required");
      valid = false;
    }

    if (!phone) {
      setPhoneError("Phone number is required");
      valid = false;
    }

    if (!password) {
      setPasswordError("Password is required");
      valid = false;
    } else if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      valid = false;
    }

    if (!valid) return;

    setLoadingTitle("Creating account...");
    setLoadingIcon(() => LoadingIcon);
    setShowLoading(true);

    dispatch(
      registerUser({ WebEmail: email, WebContact: phone, WebPass: password })
    );
  };
  if (showLoading) return <Loading title={loadingTitle} icon={loadingIcon} />;
  return (
    <div className="auth-Wrapper login tamp-login-signup">
      {/* {showLoading && <Loading title={loadingTitle} icon={loadingIcon} />} */}

      <Modal show={isOpen} onHide={onClose} size="sm">
        <ModalHeader>Create account</ModalHeader>
        <ModalBody>
          <div className="body-content">
            <div className="top-auth-part">
              <B1 className="text">Already have an account? </B1>
              <TextButton
                size="md"
                variant="secondary"
                onClick={() => {
                  onClose();
                  onSwitchToLogin();
                }}
              >
                Sign In
              </TextButton>
            </div>

            <div className="middle-auth-part">
              <div className="form-group-box">
                <div className="form-group-box-row">
                  <div className="form-group-box-col">
                    <L
                      forInput="loginEmail"
                      className="auth-email-label"
                      size="md"
                    >
                      Email
                    </L>
                    <Textbox
                      size="lg"
                      icon={CalenderIcon}
                      name="username"
                      placeholder="Enter your email here"
                      className="form-input"
                      id="loginEmail"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <SLableIcon
                      size="lg"
                      className={emailError ? "danger" : ""}
                    >
                      {emailError}
                    </SLableIcon>
                  </div>

                  <div className="form-group-box-col">
                    <L
                      forInput="phoneNumber"
                      className="auth-email-label"
                      size="md"
                    >
                      Phone
                    </L>
                    <Textbox
                      size="lg"
                      icon={Call}
                      name="phoneNumber"
                      placeholder="Enter your Phone"
                      className="form-input"
                      id="phoneNumber"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    <SLableIcon
                      size="lg"
                      className={phoneError ? "danger" : ""}
                    >
                      {phoneError}
                    </SLableIcon>
                  </div>
                </div>

                <div className="form-group-box-row">
                  <div className="form-group-box-col">
                    <L
                      forInput="password"
                      className="auth-email-label"
                      size="md"
                    >
                      Password
                    </L>
                    <Textbox
                      type="password"
                      size="lg"
                      name="password"
                      placeholder="Password"
                      className="form-input"
                      id="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <div className="form-group-box-col">
                    <L
                      forInput="confirmPassword"
                      className="auth-email-label"
                      size="md"
                    >
                      Confirm Password
                    </L>
                    <Textbox
                      type="password"
                      size="lg"
                      name="confirmPassword"
                      placeholder="Re-type Password"
                      className="form-input"
                      id="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>
                </div>

                <SLableIcon size="lg" className={passwordError ? "danger" : ""}>
                  {passwordError}
                </SLableIcon>

                {error && (
                  <SLableIcon size="lg" className="danger">
                    {typeof error === "string" ? error : "Registration failed"}
                  </SLableIcon>
                )}

                <div className="remember-me-forgot-pass">
                  <Checkbox
                    id="rememberMe"
                    name="rememberMe"
                    label="Remember me"
                    className="remember-me-checkbox"
                    size="md"
                    onChange={(val) => console.log("Checked:", val)}
                  />
                </div>

                <Button
                  className="model-button"
                  size="lg"
                  widthSize="full"
                  onClick={handleRegister}
                >
                  Create account
                </Button>
              </div>
            </div>

            <div className="sign-with-social">
              <B1 className="sign-with-social-title">
                <span>Or Sign in using</span>
              </B1>
              <div className="sign-with-social-icons">
                <ButtonWithIcon size="lg" variant="primary" icon={GoogleIcon} />
                <ButtonWithIcon
                  size="lg"
                  variant="primary"
                  icon={FacebookIcon}
                />
                <ButtonWithIcon
                  size="lg"
                  variant="primary"
                  icon={TwitterIcon}
                />
              </div>
            </div>

            <div className="bottom-auth-part">
              <B1 className="text">
                By Signing up you agree to Seedvms{" "}
                <TextButton
                  size="md"
                  className="text-button"
                  variant="secondary"
                >
                  Privacy Policy
                </TextButton>{" "}
                and{" "}
                <TextButton
                  size="md"
                  className="text-button"
                  variant="secondary"
                >
                  Terms of service
                </TextButton>
              </B1>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

export default TempSignUp;
